import React, { Component } from 'react'
import RST_pull from '../RST_pull.png';
import RST_push from '../RST_push.png';

export default class HomeTab extends Component {
    constructor(props) {
        super(props);
        //this.state = {
        //}

        this.handleClick = this.handleClick.bind(this);
        this.getStyle = this.getStyle.bind(this);
        this.getCurrentMode = this.getCurrentMode.bind(this);
    }

    handleClick(event) {
        const { name } = event.target;
        const { togglePullPush } = this.props;

        if (!togglePullPush && name === "RST_pull") {
            this.props.settingStateInParent(!togglePullPush, "togglePullPush")
        }

        if (togglePullPush && name === "RST_push") {
            this.props.settingStateInParent(!togglePullPush, "togglePullPush")
        }

    }

    getCurrentMode() {
        const { togglePullPush } = this.props;
        if (!togglePullPush) {
           return('Push')
        }

        if (togglePullPush) {
            return ('Pull')
        }
    }

    // Get style based on what the togglePullPush is set to
    getStyle(styleName) {
        const { togglePullPush } = this.props;
        if (togglePullPush && styleName === "RST_pull") {
            return ("imgActive")
        }
        if (!togglePullPush && styleName === "RST_pull") {
            return ("imgInactive")
        }

        if (!togglePullPush && styleName === "RST_push") {
            return ("imgActive")
        }
        else if (togglePullPush && styleName === "RST_push") {
            return ("imgInactive")
        }

        }

    render() {
        return (
            <div>
                <h1 className="bigQuestion">{'Looking to Develop Sprint Specific Strength?'}</h1>
                <h3 className="heading3">{'Step 1: Select your sled training device'}</h3>
                <div className="img-container">
                    <img className={this.getStyle("RST_pull")} name={"RST_pull"} src={RST_pull} alt="rst_pull" onClick={this.handleClick} />               
                    <img className={this.getStyle("RST_push")} name={"RST_push"} src={RST_push} alt="rst_push" onClick={this.handleClick} />
                </div>
                <div className="pushPullActiveContainer">
                    {this.getCurrentMode()}
                </div>

            </div>
        );
    }
}